import React from 'react';
import { Tabs } from 'antd';
import { BlueLayout, PagesContainerUI, TabsContainer } from '../../styles/styled';
import BooksExpertiseComponent from './components/BooksExpertiseComponent';
import { ExpertiseConclusionComponent } from './components/ExpertiseConclusionComponent';
import ExpertPovsConclusion from './components/ExpertPovsConclusion';

const { TabPane } = Tabs;

export const ExpertisePage = () => {
  return (
    <PagesContainerUI>
      <BlueLayout>Экспертиза</BlueLayout>
      <TabsContainer>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Учебники" key="1">
            <BooksExpertiseComponent />
          </TabPane>
          <TabPane tab="Экспертные заключения" key="2">
            <ExpertiseConclusionComponent />
          </TabPane>
          <TabPane tab="Экспертные заключения ПОВС" key="3">
            <ExpertPovsConclusion />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
